import {
    USER_ID_SCREENSHOT_REQUEST,
    USER_ID_SCREENSHOT_SUCCESS,
    USER_ID_SCREENSHOT_FAIL,
  } from '../../types/manager/screenshotTypes';

  export const screenShotDepReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case USER_ID_SCREENSHOT_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case USER_ID_SCREENSHOT_SUCCESS:
        return {
          ...state,
          loading: false,
          getIdScreenList: payload,
          error: '',
        };
      case USER_ID_SCREENSHOT_FAIL:
        return {
          ...state,
          loading: false,
          error: payload,
          getIdScreenList: [],
        };
      default:
        return state;
    }
  };